import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
const sizeMap = {
    small: pxToRem(32),
    medium: pxToRem(40),
    large: pxToRem(48),
};
export const TabsButtonText = styled.span `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
`;
export const TabButton = styled.button `
  position: relative;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: hidden;
  min-width: 0;
  padding: 0 ${theme.spacing.md};
  line-height: 1;
  color: ${theme.semantic.text[100]};
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.semibold};
  border-radius: ${theme.borderRadius.sm};
  box-shadow: none;
  background-color: transparent;
  transition: all 175ms ease-in-out;

  &:hover {
    ${(props) => !props.$active &&
    `
      cursor: pointer;
      color: ${theme.semantic.foreground.primary};
      background-color: ${theme.swatches.gray[100]};
    `}
  }

  ${(props) => props.$active &&
    `
    color: ${theme.semantic.foreground.primary};
    background-color: ${theme.semantic.surface.primary};
    box-shadow: ${theme.dropShadow[100]};
  `}
`;
export const ButtonsContainer = styled.div `
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: ${pxToRem(40)};
  width: fit-content;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.sunken};

  ${(props) => props.$stretch &&
    `
    width: 100%;
  `}

  ${(props) => props.$size &&
    `
    height: ${sizeMap[props.$size]};
  `}
`;
